import script from "./PlanOfActivities.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanOfActivities.vue?vue&type=script&setup=true&lang=js"

import "./PlanOfActivities.vue?vue&type=style&index=0&id=19d1db50&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19d1db50"]])

export default __exports__